var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPocket(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u0421\\u043B\\u043E\\u0439_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 176.5 216.5",
    enableBackground: "new 0 0 176.5 216.5",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#C9C8C8",
    d: "M44.6,199.9c-9.2,0-16.6-7.5-16.6-16.6V22.4c0-9.2,7.5-16.6,16.6-16.6H153c9.2,0,16.6,7.5,16.6,16.6v160.8 c0,9.2-7.5,16.6-16.6,16.6H44.6z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#E2E2E2",
    d: "M153,197H44.6c-7.6,0-13.8-6.2-13.8-13.8V22.4c0-7.6,6.2-13.8,13.8-13.8H153c7.6,0,13.8,6.2,13.8,13.8v160.8 C166.8,190.9,160.6,197,153,197z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#C9C8C8",
    d: "M23.6,209.8c-9.2,0-16.6-7.5-16.6-16.6V32.4c0-9.2,7.5-16.6,16.6-16.6H132c9.2,0,16.6,7.5,16.6,16.6v160.8 c0,9.2-7.5,16.6-16.6,16.6H23.6z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M132,207H23.6c-7.6,0-13.8-6.2-13.8-13.8V32.4c0-7.6,6.2-13.8,13.8-13.8H132c7.6,0,13.8,6.2,13.8,13.8v160.8 C145.8,200.8,139.6,207,132,207z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPocket);
export default __webpack_public_path__ + "static/media/pocket.74f6ed9ae38c8d268ac4a4f4d57f20eb.svg";
export { ForwardRef as ReactComponent };